
<div class="row">
  <div class="col-12 col-lg-8">
    @if (selectedYear() > 0) {
      <div class="d-flex align-items-center justify-content-between">
        <h3 class="mb-0">{{ 'DASHBOARD.TREND_OVERVIEW' | translate }}</h3>
        <div class="d-flex align-items-center">
          <div class="text-primary">{{selectedYear()}}</div>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon class="text-primary">expand_more</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @for(action of allActions$ | async; track action._id) {
              <button mat-menu-item (click)="selectedYear.set(action.year)">
                <span>{{action.year}}</span>
              </button>
            }
          </mat-menu>
        </div>
      </div>
      @if (benefitsStats$ | async; as data) {
        <app-single-tenant-overview [benefits]="benefits" [data]="data"/>
      }
    } @else if (allActions$ | async) {
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title class="fw-bold">{{ 'single-tenant-stats.component.nessun-dato' | translate }}</mat-card-title>
        </mat-card-header>
        <img mat-card-image src="assets/img/box-empty-stats-2.png" width="400" class="mx-auto mb-4">
          <mat-card-content>
          {{ 'single-tenant-stats.component.in-questa-sezione-tr' | translate }}
        </mat-card-content>
        <mat-card-actions>
            <div class="ms-auto">
              <button mat-flat-button [routerLink]="['', tenant()._id, 'account', 'purposes']">{{ 'single-tenant-stats.component.definisci-le-finalit' | translate }}</button>
              <button mat-flat-button class="ms-2" [routerLink]="['', tenant()._id, 'planning']">{{ 'single-tenant-stats.component.rendiconta-e-pianifi' | translate }}</button>
            </div>
        </mat-card-actions>
      </mat-card>
    }
  </div>

  <div class="col-12 col-lg-4 d-flex flex-column mt-3 mt-lg-0">
      <!--- LAST WORKING ON -->
      @if(lastWorkingAt$ | async; as lastWorkingAt) {
        <mat-card appearance="outlined" class="mb-4">
          <mat-card-header><mat-card-title class="fw-bold">{{ 'single-tenant-stats.component.last-working-at' | translate }}</mat-card-title></mat-card-header>
          <mat-card-content class="mt-2">
            <app-list-item-box [type]="lastWorkingAt.type" [item]="lastWorkingAt.wrapped" [tenant]="tenant()._id"/>
          </mat-card-content>
        </mat-card>
      }
    <!--- MY PROFILE -->
    @if(tenant$ | async; as _tenant) {
      <mat-card appearance="outlined" class="mb-4">
        <mat-card-header><mat-card-title class="fw-bold">{{ 'single-tenant-stats.component.my-profile' | translate }}</mat-card-title></mat-card-header>
        <mat-card-content class="mt-2">
          <mat-progress-bar class="mb-3" [value]="profileComplete(_tenant)"/>

          @if(profileComplete(_tenant) < 100) {
            <p class="text-primary">{{'DASHBOARD.PROFILE_NOT_COMPLETED' | translate}}</p>

            <ul>
              @if(!isCompanyNameSet(_tenant)) {
                <li class="mb-1">{{ 'single-tenant-stats.component.devi-impostare-il-no' | translate }}</li>
              }

              @if(!isOnePurposeSet(_tenant)) {
                <li>{{ 'single-tenant-stats.component.devi-impostare-almen' | translate }}</li>
              }
            </ul>
          } @else {
            <p class="text-primary">{{ 'single-tenant-stats.component.il-profilo-dellazien' | translate }}</p>
          }

          <div class="d-flex justify-content-end">
            <button mat-flat-button [routerLink]="[ '', tenant()._id, 'account']">{{ 'single-tenant-stats.component.completa-il-profilo' | translate }}</button>
          </div>
        </mat-card-content>
      </mat-card>
   }
</div>